import React from "react";
import { altColor } from "../../utils/constants";

export default function FavoriteNowBrandIcon({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.8 43.61">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <g id="Gruppe_90" data-name="Gruppe 90">
            <g id="Gruppe_40" data-name="Gruppe 40">
              <g id="Ebene_2-2" data-name="Ebene 2">
                <g id="Capa_1" data-name="Capa 1">
                  <path
                    fill={color}
                    d="M23.9,37.06a8.58,8.58,0,0,0-2.77-6.32,5.43,5.43,0,0,0,.88-3V24.44a3.45,3.45,0,0,0,0-4.2V18.76a10.63,10.63,0,1,0-21.26,0v9A5.45,5.45,0,0,0,2.12,31.4,8.6,8.6,0,0,0,0,37.06v6.55H13.08V41.23l5.15-9.82a6.38,6.38,0,0,1,3.42,5.65v6.55H23.9ZM10.83,43.61H2.25V37.06a6.4,6.4,0,0,1,3.42-5.65l5.16,9.82ZM8.92,30.67l.52.22-.62,1.68-1-1.85a7,7,0,0,1,.79,0h.28Zm3,7.87-1.71-3.28,1.44-3.93h.55l1.44,3.93Zm3.14-6-.62-1.7.48-.2h.32a7,7,0,0,1,.79,0ZM17,24A5.08,5.08,0,0,1,12,29.08,5,5,0,0,1,7,24.17H7V21.36a9.1,9.1,0,0,0,5.72-3,12,12,0,0,0,3.93,1.39A5,5,0,0,1,17,21.58Zm-3.92-8a1.13,1.13,0,0,0-1.58.23l-.07.12c-.88,1.57-2.51,2.5-5.14,2.93A1.82,1.82,0,0,0,4.71,21c0,.25,0,.5,0,.6v2.5a7.18,7.18,0,0,0,1.68,4.65c-.17,0-.33.1-.49.15l-.14.05a8.59,8.59,0,0,0-1.94,1A3.19,3.19,0,0,1,3,27.78v-9a8.38,8.38,0,0,1,16.76,0v.18a3.09,3.09,0,0,0-1.05,0,2.71,2.71,0,0,0-.13-.3,1.82,1.82,0,0,0-1.39-1.07A9.34,9.34,0,0,1,13,15.93Zm6.72,11.84a3.21,3.21,0,0,1-.46,1.65,9.61,9.61,0,0,0-1.14-.5L18,28.87l-.53-.16A7.28,7.28,0,0,0,19,25.77h.3a3.87,3.87,0,0,0,.48,0Zm-.48-4.23H19.2V21.59a3.17,3.17,0,0,0,0-.44h.1a1.2,1.2,0,1,1,0,2.39Z"
                  />
                  <polygon fill={color} points="21.65 43.61 21.65 43.61 21.24 43.61 21.65 43.61" />
                  <path
                    id="Pfad_1923"
                    data-name="Pfad 1923"
                    fill="#52b0b9"
                    d="M15.78,40.65h0a1.13,1.13,0,1,0,0,2.25h0a1.13,1.13,0,0,0,0-2.25Z"
                  />
                </g>
              </g>
            </g>
            <g id="Ebene_2-2-2" data-name="Ebene 2-2">
              <g id="Capa_1-2" data-name="Capa 1-2">
                <g id="WOW" isolation="isolate">
                  <text
                    isolation="isolate"
                    font-size="4px"
                    fontFamily="Lato-Bold, Lato"
                    fontWeight="800"
                    transform="translate(25.56 9.46)"
                    fill="#eb3d67"
                    letterSpacing="-0.03em"
                  >
                    W
                    <tspan letterSpacing="-0.02em" x="4.07" y="0">
                      O
                    </tspan>
                  </text>
                  <text
                    isolation="isolate"
                    font-size="4px"
                    fontFamily="Lato-Bold, Lato"
                    fontWeight="800"
                    transform="translate(32.78 9.46)"
                    fill="#eb3d67"
                    letterSpacing="-0.01em"
                  >
                    W
                  </text>
                </g>
                <path
                  id="Pfad_1954"
                  data-name="Pfad 1954"
                  fill="#eb3d67"
                  d="M28.3,0h6.8a6.7,6.7,0,0,1,6.7,6.7h0V9.24h0q0,.47-.06.93h0a6.7,6.7,0,0,1-6.64,5.76H30.7l-1.46,2.52a1.09,1.09,0,0,1-1.49.4,1.27,1.27,0,0,1-.4-.4l-1.79-3.1a6.65,6.65,0,0,1-2.09-1.47.47.47,0,0,1,.67-.65,5.85,5.85,0,0,0,1.93,1.33.43.43,0,0,1,.22.2L28.16,18a.16.16,0,0,0,.14.08.16.16,0,0,0,.13-.08L30,15.24a.46.46,0,0,1,.4-.24H35.1a5.77,5.77,0,0,0,5.76-5.76V6.7A5.78,5.78,0,0,0,35.1.93H28.3A5.78,5.78,0,0,0,22.53,6.7V9.24a5.86,5.86,0,0,0,.52,2.4.46.46,0,0,1-.24.61A.47.47,0,0,1,22.2,12a6.51,6.51,0,0,1-.6-2.79V6.7A6.7,6.7,0,0,1,28.3,0Z"
                />
                <circle id="Ellipse_13" data-name="Ellipse 13" fill="#eb3d67" cx="23.07" cy="12.75" r="0.32" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
